export default __webpack_public_path__ + "6b620dbc05a8e1249e5bb4a0fb96f63f.png";